/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Result of accepting a module version upgrade.
 */
export interface ModuleUpgradeAcceptResponse {
  moduleId: string;
  targetVersion: string;
  previousVersion: string;
}
